import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const RecommendationList: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            RecommendationList
        </div>
    )
}

export const RecommendationListSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        RecommendationList
    </div>
}

export default RecommendationList